<template>
  <div>
    <!-- Empty state when no saved datasets -->
    <v-alert
      v-if="searchStore.savedDatasets.length === 0"
      type="info"
      variant="tonal"
      class="ma-4 mx-auto"
      max-width="500"
      icon="mdi-bookmark"
      :title="$t('strings.no-saved-datasets')"
      :text="$t('strings.save-datasets-hint')"
    >
      <div class="d-flex flex-column align-center">
        <v-btn
          class="mt-4"
          prepend-icon="mdi-arrow-left"
          color="secondary"
          variant="outlined"
          @click="searchStore.setCurrentView('search')"
        >
          {{ $t('strings.back-to-search') }}
        </v-btn>
      </div>
    </v-alert>

    <!-- Saved datasets header -->
    <v-sheet v-if="searchStore.savedDatasets.length > 0" class="pa-4">
      <div class="d-flex justify-space-between align-center mb-4">
        <div class="d-flex gap-2">
          <v-tooltip :text="$t('strings.back-to-search')">
            <template v-slot:activator="{ props }">
              <v-btn
                v-bind="props"
                icon="mdi-arrow-left"
                color="primary"
                size="small"
                @click="searchStore.setCurrentView('search')"
              >
              </v-btn>
            </template>
          </v-tooltip>
        </div>
        <div>
          <h2 class="text-h5">
            {{ $t('strings.saved-datasets') }}
          </h2>
          <p class="text-body-2 text-grey mt-1 text-center">
            {{ searchStore.savedDatasetsCount }} {{ $t('strings.datasets-saved') }}
          </p>
        </div>
        <div class="d-flex gap-2">
          <v-tooltip :text="$t('strings.clear-all')">
            <template v-slot:activator="{ props }">
              <v-btn
                v-bind="props"
                icon="mdi-delete-sweep-outline"
                color="secondary"
                size="small"
                @click="confirmClearAll"
              >
              </v-btn>
            </template>
          </v-tooltip>
        </div>
      </div>
    </v-sheet>

    <!-- Saved datasets list -->
    <ResultsIterator
      :items="searchStore.savedDatasets"
      save-action-mode="fixed"
      @toggle-save="searchStore.toggleSavedDataset"
    />

    <!-- Confirm Clear All Dialog -->
    <v-dialog v-model="showClearDialog" max-width="500">
      <v-card>
        <v-toolbar flat color="secondary" class="d-flex flex-row justify-space-between">
          <v-toolbar-title class="text-white flex-shrink-0">
            {{ $t('strings.confirm-clear-all') }}
          </v-toolbar-title>
          <v-btn color="white" icon @click="closeDeleteMashup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          {{ $t('strings.confirm-clear-all-message') }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" variant="text" @click="showClearDialog = false">
            {{ $t('labels.cancel') }}
          </v-btn>
          <v-btn color="secondary darken-1" variant="text" @click="clearAll">
            {{ $t('strings.clear-all') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useSearchStore } from '@/stores/search'
import ResultsIterator from '@/components/ResultsIterator.vue'

const searchStore = useSearchStore()
const showClearDialog = ref(false)

/**
 * Show confirmation dialog before clearing all
 */
function confirmClearAll() {
  showClearDialog.value = true
}

/**
 * Clear all saved datasets
 */
function clearAll() {
  searchStore.clearSavedDatasets()
  showClearDialog.value = false
}
</script>
